// src/pages/ForgotPassword.jsx

import { useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { SITE_URL } from "../lib/config";
import { Link } from "react-router-dom";
import { Button as FcButton, Input as FcInput } from '../ui';

export default function ForgotPassword({ session, userRole, username }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();

    const redirectBase = typeof window !== 'undefined' ? window.location.origin : SITE_URL;
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${redirectBase}/reset-password`,
    });

    if (error) {
      setMessage(`Error: ${error.message}`);
    } else {
      setMessage("📧 A password reset link has been sent to your email.");
    }
  };

  return (
    <div className="min-h-screen bg-surface-canvas flex flex-col">
      {/* Green ribbon header */}
      <div className="w-full bg-ui-green py-5 px-6 flex items-center">
        <span className="text-white text-xl font-semibold">Footy Coach</span>
      </div>
      <div className="flex flex-1 items-center justify-center">
        <div className="w-full max-w-4xl rounded-lg shadow-md flex flex-col md:flex-row overflow-hidden m-4">
          {/* Left: FC Logo (desktop only) */}
          <div className="hidden md:flex flex-1 items-center justify-center bg-action-primary">
            <span className="text-[10vw] font-bold text-ui-green select-none">
              FC
            </span>
          </div>
          {/* Right: Forgot Password Form */}
          <div role="main" id="fc-main-content" className="flex-1 bg-surface-card flex flex-col justify-center p-8">
            <h1 className="text-3xl font-bold text-black mb-8 text-center md:text-left">
              Forgot Password
            </h1>
            <form onSubmit={handleReset} className="space-y-6">
              <div>
                <label
                  htmlFor="email"
                  className="block font-semibold mb-1 text-black"
                >
                  Email
                </label>
                <FcInput
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full border"
                  required
                />
              </div>
              <FcButton variant="primary"
                type="submit"
                className="w-full"
              >
                Send reset link
              </FcButton>
              {message && (
                <p className="mt-4 text-sm text-brand-text-muted">{message}</p>
              )}
            </form>
            <div className="mt-6 text-center text-black text-base">
              <span>Already have an account? </span>
              <Link
                to="/login"
                className="text-action-primary font-semibold hover:underline"
              >
                Login here
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
